<template>
    <v-container>
        <v-row justify="center" class="mb-10">
            <v-col cols="12" sm="10" md="7" lg="5">
                <TopBar backPage="booking"/>
                <v-divider class=""></v-divider>
                <v-card class="mt-3">
                    <v-card-actions>
                        <h4>
                            تاریخچه سفارشات
                        </h4>
                    </v-card-actions>
                        <v-divider
                        ></v-divider>
                    <v-card-text class="pa-1">
                        <v-card class="pa-4 border-b-sm border-solid mb-1" color="white" variant="flat"  v-for="(order,index) in $store.state.orders" :key="`order`+index">
                            <div class="d-flex justify-space-between align-center">
                                <span>
                                    شماره: <strong>{{ order.number }}</strong>
                                </span> | 
                                <span>
                                    وضعیت: 
                                    <strong :class="orderStatusColor(order.status)">
                                        {{ orderStatusText(order.status) }}
                                    </strong>
                                </span>
                                <v-btn variant="flat" icon="mdi-chevron-left" @click="$store.commit('setOrder',order);$store.commit('setActivePage', 'order_detail');"></v-btn>
                            </div>
                            <div class="d-flex justify-space-between align-center mt-2">
                                <span>
                                    {{ parseDate(order.date_created) }}
                                </span>
                                <span>
                                    <strong>{{ new Intl.NumberFormat('fa-IR').format(order.total_price) }}</strong>
                                    {{ $t('rial') }}
                                </span>
                            </div>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import TopBar from '@/components/top_bar.vue';

    export default {
        name: "OrdersPage",
        components: {
            TopBar,
        },
        data() {
            return {
                
            };
        },
        methods:{
            orderStatusText(status){
                status = Number.parseInt(status)
                let s = "نامشخص";
                switch (status) {
                    case -10:
                        s = "لغو شده"
                        break;
                    case 0:
                        s = "در انتظار پرداخت/پردازش"
                        break;
                    case 10:
                        s = "در حال آماده سازی"
                        break;
                    case 20:
                        s = "در انتظار تحویل"
                        break;
                    case 30:
                        s = "در انتظار ارسال"
                        break;
                    case 40:
                        s = "تحویل شده"
                        break;
                    default:
                        break;
                }
                return s;
            },
            orderStatusColor(status){
                status = Number.parseInt(status)
                let s = "text-red";
                switch (status) {
                    case -10:
                        s = "text-grey"
                        break;
                    case 0:
                        s = "text-warning"
                        break;
                    case 10:
                        s = "text-info"
                        break;
                    case 20:
                        s = "text-pink"
                        break;
                    case 30:
                        s = "text-lime"
                        break;
                    case 40:
                        s = "text-success"
                        break;
                    default:
                        break;
                }
                return s;
            },
            parseDate(d){
                const date = new Date(d);
                const formatter = new Intl.DateTimeFormat("fa-IR", {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                // second: "2-digit",
                hour12: false,
                });

                return formatter.format(date);
            }
        },
        async created(){
            await this.$store.dispatch('GetOrders');
        }
    };
</script>

<style>
    .text-center {
        text-align: center;
    }
    .business-card-list-item-text a, a:visited, a:hover, a:active, a:focus {
        color: black !important;
        text-decoration: none !important;
    }


    .service-img {
        border-radius: 10px;
        transition: all .2s;
        width: 120px;
        height: 120px;
        object-fit: cover;
    }
    .cat-image {
        border-radius: 10px;
        transition: all .2s;
        width: 50px;
        height: 50px;
        object-fit: cover;
    }
    .v-slide-group__content{
        justify-content: center;
    }

.text-center input {
  text-align: center;
}
</style>